import React from "react";
import { FaCalendarAlt, FaMapMarkerAlt, FaBeer } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const SessionDetails = ({ session }) => {
  const { t } = useTranslation();

  const detailItems = [
    {
      icon: FaCalendarAlt,
      label: t("history.gameHistory.time"),
      value: session.createdAt
        ? session.createdAt.toDate().toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })
        : "???",
    },
    {
      icon: FaMapMarkerAlt,
      label: t("history.gameHistory.location"),
      value: session.location || t("history.gameHistory.notSpecified"),
    },
    {
      icon: "mood",
      label: t("history.gameHistory.feeling"),
      value: session.feeling || t("history.gameHistory.notSpecified"),
    },
    {
      icon: FaBeer,
      label: t("history.gameHistory.drunk"),
      value: session.isDrunk
        ? t("history.gameHistory.yes")
        : t("history.gameHistory.no"),
      extra: session.isDrunk && (
        <p className="text-xs sm:text-sm text-test">
          {t("history.gameHistory.beer")}: {session.beerAmount / 2 || 0} L
        </p>
      ),
    },
  ];

  const renderIcon = (iconType) => {
    if (iconType === "mood") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3 sm:h-4 sm:w-4 text-test"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      );
    }

    const IconComponent = iconType;
    return <IconComponent className="h-3 w-3 sm:h-4 sm:w-4 text-test" />;
  };

  return (
    <div className="bg-secondary/30 backdrop-blur-sm rounded-lg p-3 sm:p-4 mb-4 sm:mb-6">
      <h3 className="text-test text-sm sm:text-base font-semibold mb-2 sm:mb-3">
        {t("history.gameHistory.sessionDetails")}
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        {detailItems.map((item, index) => (
          <div key={index} className="flex items-center">
            <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-test/20 flex items-center justify-center mr-2 sm:mr-3">
              {renderIcon(item.icon)}
            </div>
            <div>
              <p className="text-lightGray text-xs sm:text-sm">{item.label}</p>
              <p className="text-white text-xs sm:text-sm">{item.value}</p>
              {item.extra}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SessionDetails;
